<template>
  <div class="union">
    <Header
      :right-sidebar="true"
      :right-sidebar-title="`Редактирование профсоюза`"
    >
      <template #right-sidebar>
        <sidebar-items-group title="Отображать столбцы">
          <fields-picker
            v-model="pickedFields"
            :fields="unionHistoryDisplayableFields"
          />
        </sidebar-items-group>
        <sidebar-items-group title="Фильтры">
          <filters-group
            :fields="unionsHistoryFields"
            :items="unionHistory"
            v-model="filteredItems"
          />
        </sidebar-items-group>
        <sidebar-item
          button
          variant="warning"
          @click="deleteUnion"
          :disabled="loading"
          v-if="!isDeleted"
        >
          Удалить профсоюз
          <template #icon>
            <b-icon icon="x-square" />
          </template>
        </sidebar-item>
        <sidebar-item
          button
          variant="success"
          @click="restoreUnion"
          :disabled="loading"
          v-else
        >
          Восстановить профсоюз
          <template #icon>
            <b-icon icon="box-arrow-up-right" />
          </template>
        </sidebar-item>
        <sidebar-item
          button
          variant="danger"
          @click="showPurgeConformalModal = true"
          :disabled="loading"
        >
          Удалить профсоюз навсегда
          <template #icon>
            <b-icon icon="trash" />
          </template>
        </sidebar-item>
      </template>
    </Header>
    <Main>
      <h3 class="text-center">
        Редактирование профсоюза
      </h3>
      <b-overlay :show="loading">
        <union-form
          v-model="unionActualData"
          v-if="unionActualData !== undefined"
          class="union__form"
        />
      </b-overlay>
    </Main>
    <Main>
      <b-overlay :show="loading">
        <h3 class="text-center">История изменений абонемента</h3>
        <b-table
          selectable
          select-mode="single"
          :responsive="true"
          :items="paintedRows"
          :fields="pickedFields"
          hover
          class="table-rounded"
          empty-text="Записей нет"
        />
      </b-overlay>
    </Main>
    <b-modal
      centered
      title="Окончательное удаление профсоюза"
      v-model="showPurgeConformalModal"
      ok-title="Удалить"
      cancel-title="Отмена"
      ok-variant="danger"
      cancel-variant="success"
      @ok="purgeUnion"
    >
      <p class="my-4">
        Вы точно хотите удалить этот профсоюз?<br />(История изменений профсоюза
        будет безвозвратно утеряна, кроме того, все приписанные к этому
        профсоюзу люди, будут отписаны от него)
      </p>
    </b-modal>
    <bottom-overlay v-if="edited">
      <b-button
        @click="updateUnion"
        block
        squared
        variant="success"
        class="union__update-button"
        :disabled="loading"
      >
        Сохранить изменения
      </b-button>
      <b-button
        @click="discardChanges"
        block
        squared
        variant="warning"
        class="union__discard-changes-button"
        :disabled="loading"
      >
        Отменить изменения
      </b-button>
    </bottom-overlay>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import FieldsPicker from "@/components/Tables/FieldsPicker";
import SidebarItemsGroup from "@/components/Layout/Sidebars/SidebarItems/SidebarItemsGroup";
import FiltersGroup from "@/components/Tables/Filters/FiltersGroup";
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import BottomOverlay from "@/components/BottomOverlay";
import { displayableFields } from "@/components/Tables/defaultFields";
import axios from "@/axios";
import Main from "@/components/Layout/Main";
import { mapActions } from "vuex";
import { defaultRowPainter } from "@/components/Tables/rowPainters";
import store from "@/store";
import UnionModel from "@/components/Forms/Union/models/unionModel";
import { unionsHistoryFields } from "@/views/Unions/models/unionsFields";
import UnionForm from "@/components/Forms/Union/UnionForm";
import pageTitleMixin from "@/mixins/pageTitleMixin";
export default {
  components: {
    UnionForm,
    Main,
    BottomOverlay,
    SidebarItem,
    FiltersGroup,
    SidebarItemsGroup,
    FieldsPicker,
    Header
  },
  mixins: [pageTitleMixin],
  props: {
    unionId: {
      type: Number,
      required: true
    }
  },
  data() {
    let unionHistoryDisplayableFields = displayableFields(unionsHistoryFields);
    return {
      unionsHistoryFields,
      unionHistoryDisplayableFields,
      filteredItems: [],
      pickedFields: unionHistoryDisplayableFields,
      unionHistory: [],
      unionActualData: undefined,
      loading: true,
      showPurgeConformalModal: false
    };
  },
  computed: {
    isDeleted: ({ unionHistory }) =>
      unionHistory[0] !== undefined
        ? Boolean(Number(unionHistory[0].is_deleted))
        : false,
    edited: ({ unionActualData, unionHistory }) =>
      unionHistory[0] !== undefined &&
      JSON.stringify(unionActualData) !==
        JSON.stringify(new UnionModel(unionHistory[0])),
    paintedRows: ({ filteredItems }) => defaultRowPainter(filteredItems)
  },
  methods: {
    ...mapActions("unions", ["loadUnions"]),
    async updateUnion() {
      this.loading = true;
      try {
        await store.dispatch("unions/updateUnion", {
          id: this.unionId,
          unionData: this.unionActualData
        });
        await this.loadData();
      } catch {
        this.loading = false;
      }
    },
    discardChanges() {
      this.unionActualData = new UnionModel(this.unionHistory[0]);
    },
    async deleteUnion() {
      this.loading = true;
      await axios.delete(`/unions/${this.unionId}`);
      await this.loadData();
    },
    async restoreUnion() {
      this.loading = true;
      await axios.patch(`/unions/${this.unionId}/restore`);
      await this.loadData();
    },
    async purgeUnion() {
      this.loading = true;
      await axios.delete(`/unions/${this.unionId}/purge`);
      await this.$router.push(`/unions`);
      await this.loadUnions();
    },
    async loadData() {
      this.unionHistory = (
        await axios.get(`/unions/${this.unionId}/history`)
      ).data.union_history;
      this.unionActualData = new UnionModel(this.unionHistory[0]);
      this.loading = false;
      await this.loadUnions();
    }
  },
  async created() {
    await this.loadData();
  }
};
</script>

<style lang="scss">
.union {
  &__form {
    padding: 0 5px;
  }
}
</style>
